/**
 * URL pública canónica del producto (WhatsApp / compartir).
 * Path `/p/{id}`: mejor que hash en clientes que pierden el fragmento; hosting rewrite → index.html.
 * En producción definir VITE_PUBLIC_SITE_ORIGIN=https://lavictoria-market.com
 */
export function buildMlvProductPublicUrl(productId) {
  const id = encodeURIComponent(String(productId || '').trim());
  const envOrigin =
    typeof import.meta !== 'undefined' && import.meta.env?.VITE_PUBLIC_SITE_ORIGIN
      ? String(import.meta.env.VITE_PUBLIC_SITE_ORIGIN).replace(/\/$/, '')
      : '';
  const origin =
    envOrigin ||
    (typeof window !== 'undefined' ? String(window.location.origin || '').replace(/\/$/, '') : '');
  return `${origin}/p/${id}`;
}
